import { c as _c } from "react/compiler-runtime";
import { ROUTES } from '@openclassrooms/routing';
import { styled } from '@classify/react-core-components/styles';
import { getButtonLinkProps } from '@openclassrooms/routing';
import Box from '@classify/react-core-components/Box';
import Logo, { LOGO_VARIANTS } from './Logo';
const Root = styled(Box)(({
  theme: {
    spacing,
    breakpoints
  }
}) => ({
  marginRight: spacing(2),
  '&.mainHeaderLogo__auth': {
    display: 'flex',
    alignItems: 'center',
    height: 56,
    marginRight: spacing(0),
    [breakpoints.up('md')]: {
      height: 63
    },
    '& .mainHeaderLogo__svg': {
      width: 164,
      [breakpoints.up('sm')]: {
        width: 214
      }
    }
  },
  '& .mainHeaderLogo__link': {
    display: 'inline-block'
  },
  '& .mainHeaderLogo__svg': {
    position: 'relative',
    top: 2,
    width: 40,
    [breakpoints.up('md')]: {
      width: 143
    },
    [breakpoints.up('lg')]: {
      width: 208
    }
  },
  '& .mainHeaderLogo__svg--normal': {
    display: 'none'
  },
  '& .mainHeaderLogo__svg--compact': {
    display: 'block'
  },
  [breakpoints.up('md')]: {
    '& .mainHeaderLogo__svg--normal': {
      display: 'block'
    },
    '& .mainHeaderLogo__svg--compact': {
      display: 'none'
    }
  }
}));
const MainHeaderLogo = t0 => {
  const $ = _c(14);
  let otherProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isAuth: t1,
      onClick: t2,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const isAuth = t1 === undefined ? false : t1;
  const onClick = t2 === undefined ? _temp : t2;
  const authClassName = isAuth ? "mainHeaderLogo__auth" : "";
  let LinkComponent;
  let linkProps;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    linkProps = {
      ...getButtonLinkProps(ROUTES.HOMEPAGE.INDEX),
      className: "mainHeaderLogo__link"
    };
    LinkComponent = linkProps.component;
    delete linkProps.component;
    $[4] = LinkComponent;
    $[5] = linkProps;
  } else {
    LinkComponent = $[4];
    linkProps = $[5];
  }
  const t3 = `oc-mainHeaderLogo ${authClassName}`;
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Logo className="mainHeaderLogo__svg mainHeaderLogo__svg--compact" variant={LOGO_VARIANTS.COMPACT_BACKGROUND} />;
    t5 = <Logo className="mainHeaderLogo__svg mainHeaderLogo__svg--normal" variant={LOGO_VARIANTS.NORMAL} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onClick) {
    t6 = <LinkComponent data-event="Button|Clicked|header-logo" onClick={onClick} {...linkProps}>{t4}{t5}</LinkComponent>;
    $[8] = onClick;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== otherProps || $[11] !== t3 || $[12] !== t6) {
    t7 = <Root id="mainHeaderLogo" className={t3} {...otherProps}>{t6}</Root>;
    $[10] = otherProps;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default MainHeaderLogo;
function _temp() {}